var map = {
	"./ambassador-bg.webp": 1269,
	"./asset-2.png": 1270,
	"./btn-enter-bg.png": 1271,
	"./btn-enter-white-bg.webp": 1272,
	"./btn-more-bg.webp": 1273,
	"./casino-hover.webp": 1274,
	"./casino.webp": 1275,
	"./convenient.webp": 1276,
	"./es-bg.webp": 1277,
	"./event-sec-bg.webp": 1278,
	"./event-sport-bg.webp": 1279,
	"./fifa1-bg.jpg": 1280,
	"./fifa2-bg-cn.jpg": 1281,
	"./fifa2-bg.jpg": 1282,
	"./games-hover.webp": 1283,
	"./games.webp": 1284,
	"./gauge.webp": 1285,
	"./lottery-hover.webp": 1286,
	"./lottery.webp": 1287,
	"./master-bg.webp": 1288,
	"./p2p-hover.webp": 1289,
	"./p2p.webp": 1290,
	"./platform.webp": 1291,
	"./product-ctg-bg.webp": 1292,
	"./product-overview-bg.webp": 1293,
	"./professional.webp": 1294,
	"./safety.webp": 1295,
	"./slots-hover.webp": 1296,
	"./slots.webp": 1297,
	"./speed.webp": 1298,
	"./sports-hover.webp": 1299,
	"./sports.webp": 1300,
	"./video-bg.webp": 1301,
	"./wave.webp": 1302,
	"./wwr-bg.webp": 1303,
	"./wwr-img-b.webp": 1304,
	"./wwr-img.webp": 1305,
	"./wwr-subImg1.webp": 1306,
	"./wwr-subImg2.webp": 1307,
	"./wwr-subImg3.webp": 1308,
	"./x33-logo-cny.png": 1309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;